















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import moment from "moment";
import { ActivityDto, ActivityAreaDto } from "@/server/app.dtos";

@Component
export default class ActivityTimelineEntryComponent extends Vue {
  @Prop({ required: true }) activity!: ActivityDto;
  @Getter("activityAreas") areas!: ActivityAreaDto[];

  get area(): ActivityAreaDto | undefined {
    const id = this.activity.idActivityArea;
    return this.areas.find((i: ActivityAreaDto) => i.idActivityArea === id);
  }

  get colorStatus(): string {
    return this.activity.activityStatus?.color || "#ccc";
  }

  get colorPriority(): string {
    return this.activity.activityPriority?.color || "#ccc";
  }

  get iconArea(): string {
    return this.area?.icon || "las la-info-circle";
  }

  get daysDiff(): number {
    const dStart = moment(this.activity.dateStart);
    const dEnd = moment(this.activity.dateEnd);
    return dEnd.diff(dStart, "days");
  }
}
